import React from 'react';
import { Box, Paper, Grid, Typography, Button } from '@mui/material';

const SecaoConclusao = ({ handleBack }) => {
  return (
    <Box sx={{ mt: 6, mb: 10, width: '100%' }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Typography variant="h5" marginBottom={1.5} sx={{ 
              color: '#FDA506', 
              fontWeight: 'bold', 
              mb: 0,
              fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.5rem' }
            }}>
              Simulação Concluída!
            </Typography>
            <Typography paragraph sx={{ 
              mb: 1.5,
              fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
            }}>
              Agora que você visualizou como o modelo de fee fixo pode gerar economia e 
              previsibilidade para sua gestão patrimonial, é hora de dar o próximo passo com segurança.
              <br /><br />
              Este cálculo é aproximado e baseado nas práticas atuais de mercado, considerando uma projeção 
              de rendimento para os próximos 12 meses.
            </Typography>
            <Typography paragraph sx={{ 
              mb: 1.5,
              fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
            }}>
              Fatores como expectativa de retorno, negociações entre as partes, prazos de vencimento 
              de ativos e situação de mercado podem influenciar no resultado.
            </Typography>
            <Typography paragraph sx={{ 
              mb: 1.5,
              fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
            }}>
              A média de <strong style={{ color: '#FDA506' }}>cobrança no modelo tradicional varia entre 0,6% a 1,5%</strong> ao ano sobre 
              o patrimônio. O modelo de Fee Fixo na Monefica oferece custos mais baixos, previsíveis 
              e alinhados exclusivamente aos seus interesses.
            </Typography>
            <Typography paragraph sx={{ 
              mb: 1,
              fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
            }}>
              Somente com uma análise individualizada é possível estruturar uma estratégia sob medida, 
              considerando:
            </Typography>
            <Box component="ul" sx={{ 
              mb: 1.5, 
              pl: 2,
              fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
            }}>
              <Box component="li" sx={{ mb: 0.25 }}>O tamanho e a complexidade do seu patrimônio;</Box>
              <Box component="li" sx={{ mb: 0.25 }}>Suas metas de longo prazo e perfil de risco;</Box>
              <Box component="li" sx={{ mb: 0.25 }}>Ferramentas de eficiência tributárias que podem ser aplicadas.</Box>
            </Box>
            <Typography paragraph sx={{ 
              mb: 2,
              fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
            }}>
              Na Monefica, atuamos <strong>sem comissões ocultas</strong>. Nosso compromisso é com a proteção, 
              organização e perpetuação do seu legado.
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', md: 'row' },
              gap: { xs: 2, md: 2 },
              alignItems: { xs: 'stretch', md: 'flex-start' }
            }}>
              <Button 
                variant="contained" 
                sx={{ 
                  bgcolor: '#4CAF50', 
                  color: 'white', 
                  borderRadius: 30, 
                  px: 3, 
                  py: 1.5,
                  fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                  '&:hover': { bgcolor: '#388E3C' }
                }}
                component="a"
                href="https://calendly.com/ri-monefica"
                target="_blank"
                rel="noopener noreferrer"
              >
                Agendar com um Advisor
              </Button>
              <Button
                variant="contained"
                sx={{ 
                  bgcolor: 'primary.main', 
                  color: 'white', 
                  borderRadius: 30, 
                  px: 3, 
                  py: 1.5,
                  fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                  '&:hover': { bgcolor: 'primary.dark' }
                }}
                onClick={handleBack}
              >
                Voltar ao Simulador
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ display: { xs: 'none', md: 'block' } }}>
            <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 2 }}>
              <img 
                src="/images/calculator-phone.png" 
                alt="Celular com calculadora mostrando 30.000 e moedas"
                style={{
                  maxWidth: '100%',
                  maxHeight: '450px',
                  objectFit: 'contain'
                }}
              />
            </Box>
          </Grid>
        </Grid>
    </Box>
  );
};

export default SecaoConclusao; 